import { useToast } from "../hooks/useToast";
import Toast from "../ui/Toast";

/**
 * Global Toast Container
 * Displays toast notifications from anywhere in the app
 * 
 * Requirements: 19.4, 36.2
 */
export default function ToastContainer() {
  const { toast, hideToast } = useToast();

  if (!toast) return null;

  return (
    <Toast
      type={toast.type}
      message={toast.message}
      onClose={hideToast}
      duration={toast.duration}
    />
  );
}
